import { RobotProblem, RobotSample, RobotSampleVisible } from '../robot.types';

export function* genSamples(markup: RobotProblem['markup']): Generator<RobotSample> {
    for (let index = 0; index < markup.sample_number; index += 1) {
        if (markup.hidden_samples.includes(index)) {
            yield {
                index,
                hidden: true,
            };
        } else {
            yield {
                index,
                hidden: false,
                field: markup.samples[index],
            };
        }
    }
}

export const getVisibleSample = (markup: RobotProblem['markup']): RobotSampleVisible | null => {
    for (const sample of genSamples(markup)) {
        if (!sample.hidden) {
            return sample;
        }
    }

    return null;
};

export const getVisibleSampleIndex = (markup: RobotProblem['markup']): number => {
    for (const sample of genSamples(markup)) {
        if (!sample.hidden) {
            return sample.index;
        }
    }

    return -1;
};
